import { render, staticRenderFns } from "./JobsSettings.vue?vue&type=template&id=ba3e5710&"
import script from "./JobsSettings.vue?vue&type=script&lang=js&"
export * from "./JobsSettings.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports